export default "__VITE_ASSET__e8a9c2b5__"